import { render, staticRenderFns } from "./patient.vue?vue&type=template&id=118779dd&scoped=true&"
import script from "./patient.vue?vue&type=script&lang=ts&"
export * from "./patient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118779dd",
  null
  
)

export default component.exports